 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1LATEATNIGHT from '@/components/0_chapter1lateatnight'
 import A_CHAPTER2HEWASGOINGTOBEMAYOR from '@/components/1_chapter2hewasgoingtobemayor'
 import A_CHAPTER3THEYDIDNTDARETOSTAREATHIM from '@/components/2_chapter3theydidntdaretostareathim'
 import A_CHAPTER4ALLSTINGYPEOPLE from '@/components/3_chapter4allstingypeople'
 import A_CHAPTER5THISBOYFRIENDISABITOLD from '@/components/4_chapter5thisboyfriendisabitold'
 import A_CHAPTER6INTERESTINGGIRL from '@/components/5_chapter6interestinggirl'
 import A_CHAPTER7COMETOMYOFFICE from '@/components/6_chapter7cometomyoffice'
 import A_CHAPTER8CONCEALMENTOFMARRIAGE from '@/components/7_chapter8concealmentofmarriage'
 import A_CHAPTER9SNOWYNIGHTBYCHANCE from '@/components/8_chapter9snowynightbychance'
 import A_CHAPTER10ACOUPLEWHORESPECTEACHOTHERLIKEICE from '@/components/9_chapter10acouplewhorespecteachotherlikeice'
 import A0_CHAPTER11ASUDDENPROMOTION from '@/components/10_chapter11asuddenpromotion'
 import A1_CHAPTER12DRINKWITHHIMLATEATNIGHT from '@/components/11_chapter12drinkwithhimlateatnight'
 import A2_CHAPTER13IHAVEANIDEATHATISHOULDNTHAVE from '@/components/12_chapter13ihaveanideathatishouldnthave'
 import A3_CHAPTER14THEREAREWOMENOUTSIDE from '@/components/13_chapter14therearewomenoutside'
 import A4_CHAPTER15HEHASAVERYHIGHOPINIONOFTHEWORLD from '@/components/14_chapter15hehasaveryhighopinionoftheworld'
 import A5_CHAPTER16KISSWITHOUTTEMPERATURE from '@/components/15_chapter16kisswithouttemperature'
 import A6_CHAPTER17BLESSEDAREHE from '@/components/16_chapter17blessedarehe'
 import A7_CHAPTER18DIAZEPAM from '@/components/17_chapter18diazepam'
 import A8_CHAPTER19HEISGOINGTOSEEHERFORHIMSELF from '@/components/18_chapter19heisgoingtoseeherforhimself'
 import A9_CHAPTER20WHENDIDYOUBECOMEAFRIEND from '@/components/19_chapter20whendidyoubecomeafriend'
 import A0_CHAPTER21SHEISANELF from '@/components/20_chapter21sheisanelf'
 import A1_CHAPTER22CHANGEDHERFATE from '@/components/21_chapter22changedherfate'
 import A2_CHAPTER23WHATISTHEPURPOSEOFMARRIAGE from '@/components/22_chapter23whatisthepurposeofmarriage'
 import A3_CHAPTER24SHEHAVENOOBLIGATIONTOWAITFORHIM from '@/components/23_chapter24shehavenoobligationtowaitforhim'
 import A4_CHAPTER25REALLYACHILD from '@/components/24_chapter25reallyachild'
 import A5_CHAPTER26APERSONALVISITBYTWOPEOPLE from '@/components/25_chapter26apersonalvisitbytwopeople'
 import A6_CHAPTER27YOUCANONLYLIVEINONEROOM from '@/components/26_chapter27youcanonlyliveinoneroom'
 import A7_CHAPTER28HESOUTOFCONTROL from '@/components/27_chapter28hesoutofcontrol'
 import A8_CHAPTER29UNKNOWINGLYHISHEARTHADBEENMOVED from '@/components/28_chapter29unknowinglyhishearthadbeenmoved'
 import A9_CHAPTER30DOYOULOVEME from '@/components/29_chapter30doyouloveme'
 import A0_CHAPTER31UNCONTROLLABLEYEARNING from '@/components/30_chapter31uncontrollableyearning'
 import A1_CHAPTER32ITISVERYCLEARWHATHEWANTTODO from '@/components/31_chapter32itisveryclearwhathewanttodo'
 import A2_CHAPTER33ITSMELLSJUSTASGOODASYOUDO from '@/components/32_chapter33itsmellsjustasgoodasyoudo'
 import A3_CHAPTER34NOONEISASBOLDASYOU from '@/components/33_chapter34nooneisasboldasyou'
 import A4_CHAPTER35WOMENALWAYSHAVEATACITUNDERSTANDING from '@/components/34_chapter35womenalwayshaveatacitunderstanding'
 import A5_CHAPTER36HEISASPECIALEXISTENCE from '@/components/35_chapter36heisaspecialexistence'
 import A6_CHAPTER37BECAMEHISLOVER from '@/components/36_chapter37becamehislover'
 import A7_CHAPTER38WHATISALOVERLIKE from '@/components/37_chapter38whatisaloverlike'
 import A8_CHAPTER39WHATKINDOFMANDOYOULIKE from '@/components/38_chapter39whatkindofmandoyoulike'
 import A9_CHAPTER40INEVITABLEWORKPLACECONTACT from '@/components/39_chapter40inevitableworkplacecontact'
 import A0_CHAPTER41YOUARENOTTHEFIRST from '@/components/40_chapter41youarenotthefirst'
 import A1_CHAPTER42IWANTTOBEALONETOOMUCH from '@/components/41_chapter42iwanttobealonetoomuch'
 import A2_CHAPTER43JUSTWANTTOHUGYOU from '@/components/42_chapter43justwanttohugyou'
 import A3_CHAPTER44ITSNOTTHATEASYTOTRAPHIMTODEATH from '@/components/43_chapter44itsnotthateasytotraphimtodeath'
 import A4_CHAPTER45THEREWASALWAYSSOMEONEWHOWOULDHELPHER from '@/components/44_chapter45therewasalwayssomeonewhowouldhelpher'
 import A5_CHAPTER46ITWASAGREATINVITATIONBUTAGREATSTRUGGLE from '@/components/45_chapter46itwasagreatinvitationbutagreatstruggle'
 import A6_CHAPTER47LETHIMTAKEWHATHEWANTS from '@/components/46_chapter47lethimtakewhathewants'
 import A7_CHAPTER48THISISTHEONLYWAYTODETERMINETHERELATIONSHIP from '@/components/47_chapter48thisistheonlywaytodeterminetherelationship'
 import A8_CHAPTER49ALWAYSWORRYABOUTHER from '@/components/48_chapter49alwaysworryabouther'
 import A9_CHAPTER50HEJUSTWANTEDTOPUTANENDTOTHETROUBLE from '@/components/49_chapter50hejustwantedtoputanendtothetrouble'
 import A0_CHAPTER51ITWASBECAUSEHELIKEDHERSTUBBORNNESS from '@/components/50_chapter51itwasbecausehelikedherstubbornness'
 import A1_CHAPTER52SHEISNOTONEOFHISPEOPLE from '@/components/51_chapter52sheisnotoneofhispeople'
 import A2_CHAPTER53CANYOUPUTHIMDOWN from '@/components/52_chapter53canyouputhimdown'
 import A3_CHAPTER54HEHASANULTERIORMOTIVE from '@/components/53_chapter54hehasanulteriormotive'
 import A4_CHAPTER55DEALWITHHIMANDSENTENCEHIMTOAFORMALPUNISHMENT from '@/components/54_chapter55dealwithhimandsentencehimtoaformalpunishment'
 import A5_CHAPTER56SHEDIDNOTLOVEHIMWRONGLY from '@/components/55_chapter56shedidnotlovehimwrongly'
 import A6_CHAPTER57DONTWANTTOADMITPERSONALLYTHATYOUCANTLEAVEHER from '@/components/56_chapter57dontwanttoadmitpersonallythatyoucantleaveher'
 import A7_CHAPTER58BEMYWOMANALLRIGHT from '@/components/57_chapter58bemywomanallright'
 import A8_CHAPTER59THISISGODPUNISHINGUS from '@/components/58_chapter59thisisgodpunishingus'
 import A9_CHAPTER60IFYOUDONTGOCRAZYYOUREGOINGTOGETOLD from '@/components/59_chapter60ifyoudontgocrazyyouregoingtogetold'
 import A0_CHAPTER61IMOLDWOULDAGIRLDISLIKEME from '@/components/60_chapter61imoldwouldagirldislikeme'
 import A1_CHAPTER62WHATASILLYGIRL from '@/components/61_chapter62whatasillygirl'
 import A2_CHAPTER63THESOCALLEDYIISONTHESIDEOFTHEWATER from '@/components/62_chapter63thesocalledyiisonthesideofthewater'
 import A3_CHAPTER64WILLITLEAVEHIM from '@/components/63_chapter64willitleavehim'
 import A4_CHAPTER65DOYOUWANTTOFLYTOTHESKY from '@/components/64_chapter65doyouwanttoflytothesky'
 import A5_CHAPTER66UNUSUALWOMAN from '@/components/65_chapter66unusualwoman'
 import A6_CHAPTER67ITISEASYTOSAYTHATOTHERPEOPLEAREEASY from '@/components/66_chapter67itiseasytosaythatotherpeopleareeasy'
 import A7_CHAPTER68TOPROTECTHISLITTLEWOMAN from '@/components/67_chapter68toprotecthislittlewoman'
 import A8_CHAPTER69HEHASNEVERBEENSHORTOFWOMEN from '@/components/68_chapter69hehasneverbeenshortofwomen'
 import A9_CHAPTER70SHEWASGOINGTODRIVEHIMCRAZY from '@/components/69_chapter70shewasgoingtodrivehimcrazy'
 import A0_CHAPTER71HEISABADMAN from '@/components/70_chapter71heisabadman'
 import A1_CHAPTER72SOURWORDSOFLOVE from '@/components/71_chapter72sourwordsoflove'
 import A2_CHAPTER73REJECTION from '@/components/72_chapter73rejection'
 import A3_CHAPTER74ANOURISHEDWOMANISNOTTHESAME from '@/components/73_chapter74anourishedwomanisnotthesame'
 import A4_CHAPTER75LONGTIMENOSEE from '@/components/74_chapter75longtimenosee'
 import A5_CHAPTER76IHAVEADUTYTOTAKECAREOFYOU from '@/components/75_chapter76ihaveadutytotakecareofyou'
 import A6_CHAPTER77THISISLIKEHOME from '@/components/76_chapter77thisislikehome'
 import A7_CHAPTER78LOSINGISATERRIBLELOSS from '@/components/77_chapter78losingisaterribleloss'
 import A8_CHAPTER79THEREISNOSILVERINTHISPLACETHREEHUNDREDTAELSOFSILVER from '@/components/78_chapter79thereisnosilverinthisplacethreehundredtaelsofsilver'
 import A9_CHAPTER80SHEISTHEWEEDINTHECREVICEOFTHESTONE from '@/components/79_chapter80sheistheweedinthecreviceofthestone'
 import A0_CHAPTER81AMISCREANTGOBLIN from '@/components/80_chapter81amiscreantgoblin'
 import A1_CHAPTER82SHEISNOTWORTHYOFHIMATALL from '@/components/81_chapter82sheisnotworthyofhimatall'
 import A2_CHAPTER83SHEISHISFLOWERFAIRY from '@/components/82_chapter83sheishisflowerfairy'
 import A3_CHAPTER84HEWONTGETADIVORCE from '@/components/83_chapter84hewontgetadivorce'
 import A4_CHAPTER85THATSWHATSHEDOES from '@/components/84_chapter85thatswhatshedoes'
 import A5_CHAPTER86SHEWASNTTHEONLYONEWHOADMIREDHIM from '@/components/85_chapter86shewasnttheonlyonewhoadmiredhim'
 import A6_CHAPTER87YOUCANSEARCHYOURBODY from '@/components/86_chapter87youcansearchyourbody'
 import A7_CHAPTER88THESHARPCONFRONTATIONBETWEENTHETWOWOMEN from '@/components/87_chapter88thesharpconfrontationbetweenthetwowomen'
 import A8_CHAPTER89YOUCANTAVOIDITEVENIFYOUWANTTO from '@/components/88_chapter89youcantavoiditevenifyouwantto'
 import A9_CHAPTER90MEALSBYCHANCE from '@/components/89_chapter90mealsbychance'
 import A0_CHAPTER91SHEISNOTHISDISH from '@/components/90_chapter91sheisnothisdish'
 import A1_CHAPTER92HEGOTINTOHISCARINTHERAIN from '@/components/91_chapter92hegotintohiscarintherain'
 import A2_CHAPTER93HISBADTASTE from '@/components/92_chapter93hisbadtaste'
 import A3_CHAPTER94HEJUSTREACTEDTOHER from '@/components/93_chapter94hejustreactedtoher'
 import A4_CHAPTER95WHYDIDITHAVETOBEME from '@/components/94_chapter95whydidithavetobeme'
 import A5_CHAPTER96JUSTAWOMAN from '@/components/95_chapter96justawoman'
 import A6_CHAPTER97SHEALWAYSBELONGSTOANOTHERMAN from '@/components/96_chapter97shealwaysbelongstoanotherman'
 import A7_CHAPTER98WHOWILLACCOMPANYHIMONTHATDAY from '@/components/97_chapter98whowillaccompanyhimonthatday'
 import A8_CHAPTER99DOYOUWANTTOGETDIVORCED from '@/components/98_chapter99doyouwanttogetdivorced'
 import A9_CHAPTER100ITISNOTAGOODTIMETOBREAKUP from '@/components/99_chapter100itisnotagoodtimetobreakup'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1lateatnight",
 			"name" : "0_chapter1lateatnight",
 			"component" : A_CHAPTER1LATEATNIGHT
 		},
 		{
 			"path" : "/1_chapter2hewasgoingtobemayor",
 			"name" : "1_chapter2hewasgoingtobemayor",
 			"component" : A_CHAPTER2HEWASGOINGTOBEMAYOR
 		},
 		{
 			"path" : "/2_chapter3theydidntdaretostareathim",
 			"name" : "2_chapter3theydidntdaretostareathim",
 			"component" : A_CHAPTER3THEYDIDNTDARETOSTAREATHIM
 		},
 		{
 			"path" : "/3_chapter4allstingypeople",
 			"name" : "3_chapter4allstingypeople",
 			"component" : A_CHAPTER4ALLSTINGYPEOPLE
 		},
 		{
 			"path" : "/4_chapter5thisboyfriendisabitold",
 			"name" : "4_chapter5thisboyfriendisabitold",
 			"component" : A_CHAPTER5THISBOYFRIENDISABITOLD
 		},
 		{
 			"path" : "/5_chapter6interestinggirl",
 			"name" : "5_chapter6interestinggirl",
 			"component" : A_CHAPTER6INTERESTINGGIRL
 		},
 		{
 			"path" : "/6_chapter7cometomyoffice",
 			"name" : "6_chapter7cometomyoffice",
 			"component" : A_CHAPTER7COMETOMYOFFICE
 		},
 		{
 			"path" : "/7_chapter8concealmentofmarriage",
 			"name" : "7_chapter8concealmentofmarriage",
 			"component" : A_CHAPTER8CONCEALMENTOFMARRIAGE
 		},
 		{
 			"path" : "/8_chapter9snowynightbychance",
 			"name" : "8_chapter9snowynightbychance",
 			"component" : A_CHAPTER9SNOWYNIGHTBYCHANCE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js